import { useEffect, useState } from "react";
import { detectCorners } from "@/lib/corners";
import { logWarn } from "@/lib/log";

// Detects wall corners whenever the plan image changes
export function useCornerDetection(image, imageDims) {
  const [corners, setCorners] = useState([]);
  const [detecting, setDetecting] = useState(false);

  useEffect(() => {
    if (!image || !imageDims) { setCorners([]); return; }
    let cancelled = false;
    setDetecting(true);
    // Defer so the newly loaded image paints before the CPU-heavy pass
    const t = setTimeout(async () => {
      try {
        const found = await detectCorners(image, imageDims);
        if (!cancelled) setCorners(found);
      } catch (e) {
        logWarn("Corner detection failed", e);
        if (!cancelled) setCorners([]);
      } finally {
        if (!cancelled) setDetecting(false);
      }
    }, 50);
    return () => { cancelled = true; clearTimeout(t); };
  }, [image, imageDims]);

  return { corners, detecting };
}
